import React from 'react';
import { useHistory } from 'react-router-dom';
import { useStyletron } from 'baseui';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import { Card } from 'baseui/card';
import { CardItem } from 'commons-ui';
import { DASHBOARD_RESOURCES, PAGE_NAMES } from 'constant';
import usePermission from 'routes/usePermission';
import { URL, LABEL, GST_RESOURCES, GET_ACTION, IMAGE_SOURCE } from './gstHelper';
import { cardCSS, keyHeading, subKeyHeading } from './styles';

const useFinanceHome = () => {
	const { hasPermission } = usePermission();

	const isEnabled = (subEntity: string) => {
		return hasPermission({
			configPageName: PAGE_NAMES.dashboard,
			entity: DASHBOARD_RESOURCES.finance,
			action: GET_ACTION[subEntity]
		});
	};

	return { isEnabled };
};

const GstList: React.FC = () => {
	const history = useHistory();
	const { isEnabled } = useFinanceHome();
	const [css] = useStyletron();

	return (
		<div className={css(keyHeading)}>
			{_map(_keys(GST_RESOURCES), (subEntity) => {
				return isEnabled(subEntity) ? (
					<div
						key={subEntity}
						className={css(subKeyHeading)}
						role='button'
						tabIndex={0}
						onClick={(e) => {
							e.preventDefault();
							history.push(URL[subEntity]);
						}}>
						<Card
							overrides={{
								Root: {
									style: () => cardCSS
								},
								Body: {
									component: () => <CardItem label={LABEL[subEntity]} img={IMAGE_SOURCE[subEntity]} />
								}
							}}
						/>
					</div>
				) : null;
			})}
		</div>
	);
};

export default GstList;
